import styled from 'styled-components'
import { Row } from 'antd'

export const ContainerImage = styled.a`
  margin-right: 16px;
`

export const WrapRow = styled(Row)`
  margin-bottom: 8px;
`
